import Utility from "@/shared/utility";
import axios from "axios";
import {getHttpsCallable} from "@/shared/firebase_utils";

class Attendee{
  constructor({
    attendeeId = "",
    uid = "",
    email = "",
    hasPrizeDraw = false,
    businessCardId = "",
    dynamicLink = "",
    invitedAt = null,
    askText = "",
    offerText = "",
    noteText = "",
    joinedDate = null,
    preEventPromoShown = false,
    postEventPromoShown = false,
    isSpeaker = false,
    isRemoved = false,
    isAdmin = false,
    associatedSubEvents = [],
    associatedSpeakerSessions = [],
    accessToken = "",
    partnerRepresentativeToken = "",
    firstName = "",
    lastName = "",
    status = "",
    eventId = "",
    customLabel = "",
    ticketType = "",
    speakerId = "",
    accessibilityRequired = false,
    accessibilityNotes = "",
    dietaryRequired = false,
    dietaryNote = "",
    allowOthersToChat = false,
    allowOthersToConnect = false,
    allowOthersToMeet = false,
    stayListedOnPage = true,
    isTeamMember = false,
    isAttendee = false,
    preferredCategories = {},
    selfCategories = {},
  }) {
   
    (this.email = email || null),
    (this.businessCardId = businessCardId || ""),
    (this.attendeeId = attendeeId || ""),
    (this.dynamicLink = dynamicLink),
    (this.uid = uid),
    (this.invitedAt = invitedAt),
    (this.askText = askText || ""),
    (this.offerText = offerText || ""),
    (this.noteText = noteText || ""),
    (this.joinedDate = joinedDate || null),
    (this.isAdmin = isAdmin || false),
    (this.hasPrizeDraw = hasPrizeDraw || false),
    (this.preEventPromoShown = preEventPromoShown || false),
    (this.postEventPromoShown = postEventPromoShown || false),
    (this.isSpeaker = isSpeaker || false),
    (this.isRemoved = isRemoved || false),
    (this.associatedSubEvents = associatedSubEvents || []),
    (this.associatedSpeakerSessions = associatedSpeakerSessions || []),
    (this.accessToken = accessToken || ""),
    (this.partnerRepresentativeToken = partnerRepresentativeToken || ""),
    (this.firstName = firstName || ""),
    (this.lastName = lastName || ""),
    (this.status = status || ""),
    (this.eventId = eventId || ""),
    (this.customLabel = customLabel || ""),
    (this.ticketType = ticketType || ""),
    (this.speakerId = speakerId || ""),
    (this.accessibilityRequired = accessibilityRequired || false),
    (this.accessibilityNotes = accessibilityNotes || ""),
    (this.dietaryRequired = dietaryRequired || false),
    (this.dietaryNote = dietaryNote || ""),
    (this.allowOthersToChat = allowOthersToChat || false),
    (this.allowOthersToConnect = allowOthersToConnect || false),
    (this.allowOthersToMeet = allowOthersToMeet || false),
    (this.stayListedOnPage = stayListedOnPage || false),
    (this.isTeamMember = isTeamMember || false),
    (this.isAttendee = isAttendee || false),
    (this.preferredCategories = preferredCategories || {}),
    (this.selfCategories = selfCategories || {});
  }

  static fromObject(attendee) {
    return new Attendee({
        email: attendee.email || "",
        businessCardId: attendee.businessCardId || "",
        attendeeId: attendee.attendeeId || "",
        dynamicLink: attendee.dynamicLink || "",
        uid: attendee.uid || "",
        invitedAt:  attendee.invitedAt?.toDate() || null,
        askText: attendee.askText || "",
        offerText: attendee.offerText || "",
        noteText: attendee.noteText || "",
        joinedDate: attendee.joinedDate || null,
        isAdmin: attendee.isAdmin || false,
        hasPrizeDraw: attendee.hasPrizeDraw || false,
        preEventPromoShown: attendee.preEventPromoShown || false,
        postEventPromoShown: attendee.postEventPromoShown || false,
        isSpeaker: attendee.isSpeaker || false,
        isRemoved: attendee.isRemoved || false,
        associatedSubEvents: attendee.associatedSubEvents || [],
        associatedSpeakerSessions: attendee.associatedSpeakerSessions || [],
        accessToken: attendee.accessToken || "",
        partnerRepresentativeToken: attendee.partnerRepresentativeToken || "",
        firstName: attendee.firstName || "",
        lastName: attendee.lastName || "",
        status: attendee.status || "",
        eventId: attendee.eventId || "",
        customLabel: attendee.customLabel || "",
        ticketType: attendee.ticketType || "",
        speakerId: attendee.speakerId || "",
        accessibilityRequired: attendee.accessibilityRequired || false,
        accessibilityNotes: attendee.accessibilityNotes || "",
        dietaryRequired: attendee.dietaryRequired || false,
        dietaryNote: attendee.dietaryNote || "",
        allowOthersToChat: attendee.allowOthersToChat || false,
        allowOthersToConnect: attendee.allowOthersToConnect || false,
        allowOthersToMeet: attendee.allowOthersToMeet || false,
        stayListedOnPage: attendee.stayListedOnPage || false,
        isTeamMember: attendee.isTeamMember || false,
        isAttendee: attendee.isAttendee || false,
        preferredCategories: attendee.preferredCategories || {},
        selfCategories: attendee.selfCategories || {},
      });
  }

  toObject() {
    return {
        email: this.email || "",
        businessCardId: this.businessCardId || "",
        hasPrizeDraw: this.hasPrizeDraw || false,
        attendeeId: this.attendeeId || "",
        dynamicLink: this.dynamicLink || "",
        uid: this.uid || "",
        invitedAt: this.invitedAt || null,
        askText: this.askText || "",
        offerText: this.offerText || "",
        noteText: this.noteText || "",
        joinedDate: this.joinedDate || null,
        isAdmin: this.isAdmin || false,
        preEventPromoShown: this.preEventPromoShown || false,
        postEventPromoShown: this.postEventPromoShown || false,
        isSpeaker: this.isSpeaker || false,
        isRemoved: this.isRemoved || false,
        associatedSubEvents: this.associatedSubEvents || [],
        associatedSpeakerSessions: this.associatedSpeakerSessions || [],
        accessToken: this.accessToken || "",
        partnerRepresentativeToken: this.partnerRepresentativeToken || "",
        firstName: this.firstName || "",
        lastName: this.lastName || "",
        status: this.status || "",
        eventId: this.eventId || "",
        customLabel: this.customLabel || "",
        ticketType: this.ticketType || "",
        speakerId: this.speakerId || "",
        accessibilityRequired: this.accessibilityRequired,
        accessibilityNotes: this.accessibilityNotes,
        dietaryRequired: this.dietaryRequired,
        dietaryNote: this.dietaryNote,
        allowOthersToChat: this.allowOthersToChat,
        allowOthersToConnect: this.allowOthersToConnect,
        allowOthersToMeet: this.allowOthersToMeet,
        stayListedOnPage: this.stayListedOnPage,
        isTeamMember: this.isTeamMember,
        isAttendee: this.isAttendee,
        preferredCategories: this.preferredCategories,
        selfCategories: this.selfCategories,
    };
  }

  // getInvitationStatus(){
  //   switch(this.invitationStatus){
  //     case "INVITE_SENT": return "Invited";
  //     case "ACCEPTED": return "Accepted";
  //     case "PENDING": return "Sending Invitation";
  //     case "FAILED": return "Error sending invitation";
  //     default: 
  //     return "Invited";
  //   }
  // }

  async generatePrivateLink(eventId, eventName){
    let deepLink = '';
    if (this.isSpeaker) {
      deepLink = `https://app.pappyon.com/event/${eventId}/?speakerToken=${this.accessToken}`;
    } else {
      deepLink = `https://app.pappyon.com/event/${eventId}/?accessToken=${this.accessToken}`;
    }
    this.dynamicLink = deepLink;
  }

  async sendInvitation(linkPrivacy, eventLink, eventName, firstName, lastName, hostName){
    let invitedBy = hostName != '' ? hostName : firstName + " " + lastName;
    const isSpeaker = this.speakerId != '' && this.speakerId != undefined && this.speakerId != null;
    if(linkPrivacy == 'Public'){
      //Start: Send invitation email to attendee
      // await this.timeout(300);
      // return {data: {success: true}};
      const sendEventInvitation = getHttpsCallable("sendEventInvitation");
      let result = await sendEventInvitation({
        email: this.email,
        eventName: eventName,
        //Remove https:// from eventLink
        dynamicLink: eventLink.replace(/^https?\:\/\//i, ""),
        hostName: invitedBy,
        firstName: this.firstName,
        isSpeaker: isSpeaker,
        isAdmin: this.isAdmin
      });
      return result;
      //End: Send invitation email to attendee
    } else {
      //Start: Send invitation email to attendee
      console.log('private');
      const sendEventInvitation = getHttpsCallable("sendEventInvitation");
      let result = await sendEventInvitation({
        email: this.email,
        eventName: eventName,
        hostName: invitedBy,
        dynamicLink: eventLink.replace(/^https?\:\/\//i, ""),
        firstName: this.firstName,
        isSpeaker: isSpeaker,
        isAdmin: this.isAdmin
      });
      return result;
      //End: Send invitation email to attendee
    }
  }
  async timeout(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

 

}
export default Attendee;
